import type { ButtonHTMLAttributes, FC, ReactNode } from 'react';

type LoadingButtonProps = {
  isLoading?: boolean;
  loadingText?: string;
  children: ReactNode;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export const LoadingButton: FC<LoadingButtonProps> = ({
  isLoading = false,
  loadingText = 'Carregando...',
  children,
  disabled,
  className = '',
  ...rest
}) => {
  const isDisabled = disabled || isLoading;

  return (
    <button
      className={`flex items-center transition-all justify-center gap-2 disabled:bg-bg-disabled disabled:text-text-disabled disabled:cursor-not-allowed ${className}`}
      disabled={isDisabled}
      {...rest}
    >
      {isLoading && (
        <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-white border-t-transparent" />
      )}
      <span>{isLoading ? loadingText : children}</span>
    </button>
  );
};
